interface IgetBaseButtonStyles {
  color: string;
  background: string;
  buttonShape: string;
  borderRadius: number | string;
  fontFamily: string;
  fontWeight?: number | string;
  buttonOutline: boolean;
  useLargeButton?: boolean;
  hoverColor?: string;
  buttonShadow: boolean;
  type?: 'navigation' | 'generic' | undefined;
}

interface IButtonType {
  type?: 'navigation' | 'generic';
}

const getBaseButtonStyles = ({
  color = '#fff',
  fontFamily,
  fontWeight = 400,
  background = '#060709',
  buttonShape = 'pill',
  borderRadius,
  buttonOutline = false,
  useLargeButton = false,
  hoverColor,
  buttonShadow = false,
  type = undefined,
}: IgetBaseButtonStyles) => {
  //
  let minWidth = useLargeButton ? 310 : 230;
  let maxWidth = useLargeButton ? 310 : 230;

  if (buttonShape === 'circle') {
    minWidth = 80;
    maxWidth = 180;
  }

  const buttonShape_ = {
    pill: {
      borderRadius: '9999px',
    },
    rectangle: {
      borderRadius,
    },
    circle: {
      // minWidth,
      // maxWidth,
      borderRadius: '50%',
      padding: 20,
      aspectRatio: '1 / 1',
    },
  }[buttonShape];

  return {
    outline: 'none',
    border: `1px solid ${background}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth,
    maxWidth,

    minHeight: useLargeButton ? '65px !important' : 45,
    ...(type === 'navigation' && {
      margin: 10,
    }),

    padding: '8px 32px',
    cursor: 'pointer',
    background,
    ...buttonShape_,
    fontSize: 14,
    fontFamily: `${fontFamily || 'inherit'} !important`,
    fontWeight: `${fontWeight} !important`,
    color,
    ...(buttonOutline && {
      background: 'transparent',
    }),
    textAlign: 'center',

    ...(buttonShadow && {
      boxShadow: '0 0 12px 3px rgba(0, 0, 0, 0.09)',
    }),

    ':hover': {
      ...(hoverColor
        ? {
            background: hoverColor,
            border: `1px solid ${hoverColor || background}`,
          }
        : {
            opacity: 0.8,
          }),
    },
  };
};

export { IgetBaseButtonStyles, getBaseButtonStyles };
